/* eslint-disable jsx-a11y/anchor-is-valid */

import * as React from "react";

import {RouteComponentProps, withRouter} from "react-router";
import {LoadingViewState, RouterView} from "../RouterView";
import {CasinoGame, CasinoGameTranslation, CasinoGameType, GameTag} from "../../http/protocol";
import {Form, FormListener} from "../form/Form";
import {getContainer} from "../../ioc/IOCSetup";
import {FormGroup} from "../form/FormGroup";
import {FormInput} from "../form/FormInput";
import {Validators} from "../form/Validators";
import {FormSubmitError, FormSubmitSuccess} from "../form/FormFeedback";
import {Submit} from "../form/Submit";
import {CasinoGameService} from "../../services/CasinoGameService";
import {BindModel, FormList, ModelBinding} from "../form/FormList";
import {formatInstant} from "../../util/date";
import {CasinoGameTagService} from "../../services/CasinoGameTagService";
import {SelectInput} from "../form/SelectInput";
import { Fragment } from "react";
import { Modal } from "react-bootstrap";


interface State extends LoadingViewState {
    game? : CasinoGame;
    gameOrder? : CasinoGame;
    tags?: GameTag[];
    validationMap? : any;
    showModal?: boolean;
    actualOrder?:number;
    disabledSaved?:boolean;
}
let types = [CasinoGameType.ARCADE_GAMES, CasinoGameType.LIVE_CASINO, CasinoGameType.SLOTS, CasinoGameType.TABLE_GAMES, CasinoGameType.VIDEO_POKER, CasinoGameType.OTHER];
export class EditCasinoGameView extends RouterView<RouteComponentProps,State> implements FormListener<CasinoGame>{

    service : CasinoGameService;
    tagService : CasinoGameTagService;

    constructor(props : RouteComponentProps){
        super(props);
        this.service = getContainer().getCasinoGameService();
        this.tagService = getContainer().getCasinoGameTagService();
        this.state = { game : {}, gameOrder: {}, validationMap : {}, tags : [], showModal:undefined, disabledSaved:false };
    }

    getTitle(): string {
        return "Edit Casino Game";
    }

    componentDidUpdate(prevProps : RouteComponentProps, prevState : State) {
        if((prevProps.match.params as any).id !== (this.props.match.params as any).id)  {
            this.refreshContent();
        }
    }
    sortTranslations(s : CasinoGame) {
        if(s.translations) {
            s.translations.sort((a,b)=>{
                if(!a.language) {
                    return 1;
                } else if(!b.language) {
                    return 1;
                } else  if(!a && !b) {
                    return 0;
                }
                return a.language.localeCompare(b.language);
            })
        }
    }
    loadContent(): Promise<any>  {
        return this.service.getEntity((this.props.match.params as any).id).then((s : CasinoGame) => {
            this.sortTranslations(s);
            this.setState({ game : s , actualOrder: s.gameOrder});
            console.log("loaded game with tags", s);
            return this.tagService.list({offset : 0, limit: 1000, orderBy: "name", ascending : true} as any).then( (response)=>{
                this.setState({ tags : response.items });
            })
        });
    }

    onSubmit()  {
        if(!this.state.game) return;
        return this.service.save(this.state.game).then((g : CasinoGame)=> {
            this.sortTranslations(g);
            this.setState({game: g});
        })
    }

    formDidUpdate(formModel: CasinoGame, validationMap?: any) {
        this.setState({game : formModel, validationMap : validationMap})
    }

    addTranslation() {
        if(this.state.game && this.state.game.translations) {
            let translations = this.state.game.translations.concat([{}])
            let game = {...this.state.game,  translations : translations };
            this.sortTranslations(game);
            this.setState({ game : game})
        } else {
            let game = {...this.state.game,  translations : [{}] };
            this.setState({ game : game})
        }
    }

    getOrder=(event:any)=>{
        let orderId:number = Number(event.target.value);
        let actualOrder = Number(this.state.actualOrder);
        getContainer().getCasinoGameService().getGameByGameOrder(orderId).then((g : CasinoGame)=> {
            if(g!==undefined){
                let gameOrder = g.gameOrder===undefined? undefined : Number(g.gameOrder);
                if(orderId===actualOrder){
                    this.setState({showModal:undefined, disabledSaved: false});
                }else{
                    if(Number(orderId)!==gameOrder){
                        this.setState({showModal:undefined, disabledSaved: false});
                    }else{
                        this.setState({showModal:true, disabledSaved:true, gameOrder:g});
                    }
                } 
            }
        });
    }

    closeModal(){
        this.setState({showModal:undefined})
    }

    renderContent() {
        if(!this.state.game || !this.state.tags) {
            return <span></span>
        }

        return (
            <div>
                <div className="wrapper wrapper-0content animated fadeInRight">
                    <Form className="form form-horizontal" validationMap={this.state.validationMap} modelObject={this.state.game} formListener={this}>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card-box">
                                    <h5>Account Info</h5>
                                    <div className="ibox-content">

                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">ID</label>
                                            <div className="col-sm-10">
                                                <FormInput  model="id" type="integer"  className="form-control" disabled={true}/>
                                            </div>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Name</label>
                                            <div className="col-sm-10">
                                                <FormInput  model="name" type="text"  className="form-control" required={true}/>
                                            </div>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Image URL</label>
                                            <div className="col-sm-10">
                                                <FormInput  model="imageUrl" type="text"  className="form-control" />
                                            </div>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Release Date</label>
                                            <div className="col-sm-10">
                                                <span>{formatInstant(this.state.game.releaseDate, "YYYY-MM-DD")}</span>
                                            </div>
                                        </FormGroup>



                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Integration</label>
                                            <div className="col-sm-10">
                                                <FormInput  model="integration" type="text"  className="form-control" disabled={true}/>
                                            </div>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Studio</label>
                                            <div className="col-sm-10">
                                                <FormInput  model="studio.name" type="text"  className="form-control" disabled={true} />
                                            </div>
                                        </FormGroup>
                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group mb-3" model="gameType">
                                            <label>Game Type</label>
                                            <SelectInput optional={false} multiple={false}
                                                         size={types.length}
                                                         values={types} className="form-control" model="gameType"
                                            />
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group mb-3" model="gameTags">
                                            <label>Game Tags</label>
                                            <SelectInput optional={true} multiple={true}
                                                         convertOptionValueToModel={(str)=> {
                                                             if(this.state.tags) {
                                                                return this.state.tags.find(t => ""+t.id === str)
                                                             } else {
                                                                 return undefined;
                                                             }
                                                         }}
                                                         convertModelValueToOption={(tags : GameTag[])=>tags.map((t:GameTag)=>t.id)}
                                                         size={this.state.tags.length}
                                                         values={this.state.tags} className="form-control" model="gameTags"
                                                         displayValue={(t)=>t.name}
                                                         optionModelValue={(t)=>t.id}
                                            />
                                        </FormGroup>



                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Enabled</label>
                                            <div className="col-sm-10">
                                                <FormInput  model="enabled" type="checkbox" />
                                            </div>
                                        </FormGroup>
                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-4 control-label">Studio Is Play For Fun Enabled</label>
                                            <div className="col-sm-10">
                                                {
                                                    this.state.game.studio!==undefined && (
                                                        <span>{this.state.game.studio.playForFunEnabled ? "Yes" : "No"}</span>
                                                    )
                                                }
                                            </div>
                                        </FormGroup>
                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Play For Fun</label>
                                            <div className="col-sm-10">
                                                {this.state.game.studio!==undefined && this.state.game.studio.playForFunCapable ===true &&  (
                                                    <FormInput  model="playForFun" type="checkbox" />
                                                )}
                                                
                                                {this.state.game.studio!==undefined && this.state.game.studio.playForFunCapable ===false &&  (
                                                    <Fragment>
                                                        <FormInput model="playForFun" type="checkbox" checked={false} disabled={true}/>
                                                    </Fragment>
                                                )}
                                            </div>
                                        </FormGroup>
                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Removed</label>
                                            <div className="col-sm-10">
                                                <span>{this.state.game.removed ? "Yes" : "No"}</span>
                                            </div>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Background Image URL</label>
                                            <div className="col-sm-10">
                                              <FormInput className="form-control" model={"backgroundImageUrl"} />
                                            </div>
                                        </FormGroup>
                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Description</label>
                                            <div className="col-sm-10">
                                              <FormInput className="form-control" type="textarea" model={"description"} />
                                              <span className={"help-block"}>Short description of the game for marketing purposes. It should not be used to explain rules nor any lengthy explanation</span>
                                            </div>
                                        </FormGroup>
                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Order</label>
                                            <div className="col-sm-10">
                                              <FormInput className="form-control" type="number" model={"gameOrder"} optional={true} onChangeCapture={this.getOrder}/>
                                              <span className={"help-block"}>Used to determine display order in player frontend. When empty game will be ordered last using game id</span>
                                            </div>
                                        </FormGroup>
                                        

                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card-box">
                                    <h5>Translations</h5>
                                    <div className="ibox-content">

                                        <FormList model={"translations"}>
                                            <div className="hr-line-dashed"></div>
                                            <FormGroup className="form-group">
                                                <label className="col-sm-2 control-label">Language</label>
                                                <div className="col-sm-10">
                                                    <FormInput  model="language" validators={[Validators.required()]} type="text"  className="form-control" />
                                                </div>
                                            </FormGroup>
                                            <FormGroup className="form-group">
                                                <label className="col-sm-2 control-label">Name</label>
                                                <div className="col-sm-10">
                                                    <FormInput  model="name" type="text"  className="form-control" />
                                                </div>
                                            </FormGroup>
                                            <FormGroup className="form-group">
                                                <label className="col-sm-2 control-label">Image Url</label>
                                                <div className="col-sm-10">
                                                    <FormInput  model="imageUrl" type="text"  className="form-control" />
                                                </div>
                                            </FormGroup>
                                            <FormGroup className="form-group">
                                                <label className="col-sm-2 control-label">Description</label>
                                                <div className="col-sm-10">
                                                <FormInput className="form-control" type="textarea" model={"description"} />
                                                <span className={"help-block"}>Short description of the game for a particular Language for marketing purposes. It should not be used to explain rules nor any lengthy explanation</span>
                                                </div>
                                            </FormGroup>
                                            <div className={"col-sm-10"}>
                                                <BindModel render={(b : ModelBinding<CasinoGameTranslation>)=>{
                                                    return <a onClick={(e:any)=> { e.preventDefault();  b.removeCurrentItem(); }} className={"btn btn-danger"} style={{ float : "right"}}>Remove</a>
                                                }}/>
                                            </div>
                                        </FormList>
                                        <div className="hr-line-dashed"></div>
                                        <div>
                                            <a  onClick={(e:any)=> { e.preventDefault(); this.addTranslation();}} className={"btn btn-primary"}>Add Translation</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card-box">

                                    <FormSubmitError />
                                    <FormSubmitSuccess text="Casino Game was updated successfully"/>
                                    <div className="form-group">
                                        <div className="col-sm-12">
                                            <Submit disabled={this.state.disabledSaved} className="btn  btn-primary">Save</Submit>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">   
                                {
                                    this.state.showModal===true && (
                                        <ErrorModalOrderCasino
                                            show={this.state.showModal}
                                            hideCancelButton={true}
                                            hideOkButton={true}
                                            heading="Oops, something went bonker!"
                                            gameOrder={this.state.gameOrder}
                                            okLabel="OK"
                                            onOk={
                                                this.closeModal.bind(this)
                                            }
                                            onCancel={this.closeModal.bind(this)}
                                        />
                                    )
                                }
                                
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }

}

export default withRouter(EditCasinoGameView);


interface Props { 
    show?: boolean,
    okLabel: string,
    cancelLabel?: string,
    heading: string,
    okClassName?: string,
    cancelClassName?: string,
    gameOrder?:CasinoGame;
    hideCancelButton? : boolean,
    hideOkButton? : boolean,
    onOk: () => void, 
    onCancel?: () => void,
    disableActions?: boolean
}

export class ErrorModalOrderCasino extends React.Component<Props, {}>{

    async onCancel() {
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    }

    async doOk() {
        this.props.onOk();
    }

    getActions() {
        let btnCancelClass = this.props.cancelClassName ? this.props.cancelClassName : "btn-primary";
        let btnClass = this.props.okClassName ? this.props.okClassName : "btn-danger";
        let btnCancel = this.props.cancelLabel ? this.props.cancelLabel : "Cancel";
        let hideCancelButton = this.props.hideCancelButton ? this.props.hideCancelButton : false;
        let hideOkButton = this.props.hideOkButton ? this.props.hideOkButton : false;
        return (
            <FormGroup className="form-group">
                <div> 
                    {!hideCancelButton && 
                        ( <a href="/#"  className={`btn ${btnCancelClass}`} onClick={(e)=>{ e.preventDefault(); this.onCancel.bind(this)}}>{btnCancel}</a>)
                    }
                    {!hideOkButton && 
                        ( <a  href="/#" className={`btn ${btnClass}`} onClick={(e)=>{ e.preventDefault(); this.doOk.bind(this)}}>{this.props.okLabel}</a>)
                    }
                </div>
            </FormGroup>
        );
    }

    render() {
        let domain = window.location.origin;
        let casinoName = this.props.gameOrder!.name;
        let studioName = this.props.gameOrder!.studio === undefined ? ""  :  this.props.gameOrder!.studio.name;
        let id = this.props.gameOrder!.id;
        let order = this.props.gameOrder!.gameOrder;
        let url = domain.concat("/casino-game/".concat(id===undefined? "": id.toString()));
        return (
            <Modal show={this.props.show} onHide={this.onCancel.bind(this)} aria-labelledby="contained-modal-title">
                <Modal.Header  closeButton>
                    <Modal.Title id="contained-modal-title">{this.props.heading}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={'alert alert-danger'}>{"The order of play cannot be changed. Another game contains this order."}</div>
                    <div className={'alert alert-danger'}>{"ID: "+id}</div>
                    <div className={'alert alert-danger'}>{"Name: "+casinoName}</div>
                    <div className={'alert alert-danger'}>{"Studio: "+studioName}</div>
                    <div className={'alert alert-danger'}>{"Order: "+order}</div>
                    <div className={'alert alert-danger'}>{"Url: "}<a href={url}>{url}</a></div>
                </Modal.Body>
                {
                    (this.props.disableActions===undefined || this.props.disableActions===false) && (
                    <Modal.Footer>
                        {this.getActions()}
                    </Modal.Footer>
                    )
                }
                
            </Modal>
       );
    }
}